import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomBillomatArticlesConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomBillomatArticlesConfigQuery = { __typename?: 'Query', getCustomBillomatArticlesConfig?: string | null };


export const GetCustomBillomatArticlesConfigDocument = gql`
    query getCustomBillomatArticlesConfig {
  getCustomBillomatArticlesConfig
}
    `;

/**
 * __useGetCustomBillomatArticlesConfigQuery__
 *
 * To run a query within a React component, call `useGetCustomBillomatArticlesConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomBillomatArticlesConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomBillomatArticlesConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomBillomatArticlesConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomBillomatArticlesConfigQuery, GetCustomBillomatArticlesConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomBillomatArticlesConfigQuery, GetCustomBillomatArticlesConfigQueryVariables>(GetCustomBillomatArticlesConfigDocument, options);
      }
export function useGetCustomBillomatArticlesConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomBillomatArticlesConfigQuery, GetCustomBillomatArticlesConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomBillomatArticlesConfigQuery, GetCustomBillomatArticlesConfigQueryVariables>(GetCustomBillomatArticlesConfigDocument, options);
        }
export type GetCustomBillomatArticlesConfigQueryHookResult = ReturnType<typeof useGetCustomBillomatArticlesConfigQuery>;
export type GetCustomBillomatArticlesConfigLazyQueryHookResult = ReturnType<typeof useGetCustomBillomatArticlesConfigLazyQuery>;
export type GetCustomBillomatArticlesConfigQueryResult = Apollo.QueryResult<GetCustomBillomatArticlesConfigQuery, GetCustomBillomatArticlesConfigQueryVariables>;